import { render, staticRenderFns } from "./Refunds.vue?vue&type=template&id=d1618d6c&scoped=true"
import script from "./Refunds.vue?vue&type=script&lang=js"
export * from "./Refunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1618d6c",
  null
  
)

export default component.exports